import { API_ROOT } from '../../config/config'
import { doGet } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getTopLevelNavSchema = () => {
  const url = `${API_ROOT}/proposal/top-level-nav/menu`
  return doGet(url)
}
